// extracted by mini-css-extract-plugin
module.exports = {"vanlife-F":"F_vanlife-F___Y5I9"};